import { render } from "./Message.vue?vue&type=template&id=14ce3a86&scoped=true"
const script = {}

import "./Message.vue?vue&type=style&index=0&id=14ce3a86&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-14ce3a86"

export default script